import type { Meta, StoryObj } from "@storybook/react";

import type { TabButtonProps } from "@/ui/core";
import { TabButton } from "@/ui/core";

const StoryMeta: Meta<TabButtonProps> = {
  title: "Core/Tab Button",
  component: TabButton,
  argTypes: {
    badgeCount: { control: "number" },
    isActive: { control: "boolean" },
    onPress: { action: "Tab button pressed" },
    testID: { control: "text" },
    title: { control: "text" },
  },
  args: {
    badgeCount: 4,
    isActive: false,
    testID: "storybook",
    title: "Olivia",
  },
};

type Story = StoryObj<TabButtonProps>;

const Primary: Story = {};

const IsActive: Story = {
  ...StoryMeta,
  args: {
    isActive: true,
  },
};

const WithZeroNumber: Story = {
  ...StoryMeta,
  args: {
    badgeCount: 0,
  },
};

export { IsActive, Primary, WithZeroNumber };
export default StoryMeta;
